import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import "./weddinginvitationpage.css";
import CardMedia from '@mui/material/CardMedia';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'transparent',
  border: '0px solid #000',
  boxShadow: 0,
  p: 4,
};

export default function Invitationone() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Button onClick={handleOpen}>
        <img alt = '' src={process.env.PUBLIC_URL + "images/sriram.png"}  className="invitationone"  />
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
          <Box sx={style}>
          <CardMedia
            component='video'
            autoPlay //////////////////Used to auto autoplay the video//////////////
            controls="top"
            image={"https://storage.googleapis.com/airlift-cdn/sriram.mp4"}  
            className="cardmediathree"
          />
        </Box>
      </Modal>
    </div>
  );
}
